import React, {memo, useContext} from 'react';
import flatten from 'lodash/flatten';

import './PaymentDetails.less';

import {PaymentTypes} from "new-constants/common.constants";

import {getSafeTranslation} from "helpers/localization.helper.ts";
import {convertPrice} from "helpers/format.helper";
import {getPaymentTypeName} from "helpers/purchase.helper.ts";

import {CartPicker} from '../cart-picker/CartPicker';
import {CartPickerTrigger} from '../cart-picker-trigger/CartPickerTrigger';
import {Tip} from '../tip/Tip';
import {PromocodeList} from '../promocode-list/PromocodeList';
import {CartPickerTriggerIcon} from 'elements/cart-picker-trigger-icon/CartPickerTriggerIcon';
import {Checkbox} from "elements/checkbox/Checkbox.tsx";
import {List} from "elements/list/List.tsx";
import {ListItem} from "elements/list-item/ListItem.tsx";
import {RoundTipButton} from "elements/round-tip-button/RoundTipButton";
import {SelectList} from "compositions/select-list/SelectList";
import {SelectListItem} from "compositions/select-list-item/SelectListItem.tsx";

import {TranslationsContext} from "contexts/translations-context";

import PromoIcon from 'new-images/promo.svg';
import {Card, CardStyles} from "../../elements/card/Card";
import {EmptyPlaceholder} from "../../elements/empty-placeholder/EmptyPlaceholder";
import Platform from '../../../platform';

export const PaymentDetails = memo(({
																			selectedPaymentType,
																			selectedSubPaymentType,																			paymentTypes,
																			subPaymentTypes,
																			cashpointsName,
																			useCashPoints,
																			availableCashpoints = 0,
																			isShowTips = false,
																			tipPercent,
																			isShowPromocode,
																			promocodes = [],
																			onCashpointsClick,
																			onPromocodeClick,
																			onTipPercentClick,
																			roundUpTip,
																			onRoundTipClick,
																			roundUpPercent,
																			onPaymentTypeClick
																		}) => {

	const translations = useContext(TranslationsContext);
	return (
		<List>
			<ListItem key="payment-type" isIncreasedBorderPadding>
				<CartPicker title={getSafeTranslation('PaymentDetails.paymentTypeLabel', translations)}>
					{
						paymentTypes.length > 0
							? (<SelectList>
								{
									flatten(
										paymentTypes
										.filter(paymentType => !Platform.isIOs ? paymentType !== PaymentTypes.payWithApplePay : true)
										.map(paymentType => {

										if (paymentType === PaymentTypes.customPaymentType) {
											return subPaymentTypes.map(subPaymentType => {
												const isSelected = selectedSubPaymentType?.id === subPaymentType.id;
												return <SelectListItem
													checkboxControl={<Checkbox isChecked={isSelected} isRadio/>}
													key={`${paymentType}-${subPaymentType.id}`}
													name={subPaymentType.name}
													isSelected={isSelected}
													onClick={() => {
														onPaymentTypeClick(paymentType, subPaymentType.id)
													}}
												/>
											})
										} else {
											const isSelected = paymentType === selectedPaymentType;
											return (<SelectListItem
												checkboxControl={<Checkbox isChecked={isSelected} isRadio/>}
												key={paymentType}
												name={getPaymentTypeName(
													paymentType,
													null,
													cashpointsName,
													translations)}
												isSelected={isSelected}
												onClick={() => {
													onPaymentTypeClick(paymentType)
												}}
											/>);
										}

									}))
								}
							</SelectList>)
							: (<Card style={CardStyles.NESTED}>
								<EmptyPlaceholder text={getSafeTranslation('SelectPaymentTypePopup.emptyPlaceholder', translations)}/>
							</Card>)
					}
				</CartPicker>
			</ListItem>

			{availableCashpoints > 0 && (
				<ListItem key="cashpoints" onClick={() => onCashpointsClick(!useCashPoints)} isIncreasedBorderPadding>
					<CartPicker title={cashpointsName}>
						<CartPickerTrigger
							icon={<Checkbox isChecked={useCashPoints} isRadio/>}
							text={getSafeTranslation('PaymentDetails.cashpointsCheckboxCaption', translations)
								.replace('{availableAmount}', availableCashpoints)
								.replace('{cashpointsName}', cashpointsName)
							}
						/>
					</CartPicker>
				</ListItem>
			)}
			{
				isShowPromocode && (
					<ListItem key="promocode" onClick={onPromocodeClick} isIncreasedBorderPadding>
						<CartPicker title={getSafeTranslation('PaymentDetails.promocodeLabel', translations)}>
							{promocodes.length > 0 ? (
								<PromocodeList promocodes={promocodes}/>
							) : (
								<CartPickerTrigger icon={<CartPickerTriggerIcon icon={PromoIcon}/>}
									text={getSafeTranslation('PaymentDetails.promocodeNotSelectedPickerCaption', translations)}/>
							)}
						</CartPicker>
					</ListItem>
				)
			}
			{
				isShowTips && (
					<ListItem key="tip" isIncreasedBorderPadding>
						<CartPicker title={getSafeTranslation('PaymentDetails.tipLabel', translations)}>
							<Tip percents={[5, 10, 15, 20]} selectedPercent={tipPercent}
									 onPercentClick={(percent) => onTipPercentClick(percent)}/>
						</CartPicker>
						<RoundTipButton
							text={getSafeTranslation('PaymentDetails.roundUpButtonCaption', translations).replace('{amount}', convertPrice(roundUpTip))}
							isPressed={tipPercent === roundUpPercent}
							onClick={() => onRoundTipClick(tipPercent === roundUpPercent ? 0 : roundUpPercent)}/>
					</ListItem>
				)
			}
		</List>
	);
});
